(function () {
  const RATE = 0.07; // 7%

  function formatMoneyFromCents(cents) {
    const dollars = (cents / 100) * RATE;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(dollars);
  }

  async function updateDonation() {
    const el = document.getElementById('hfDonationAmount');
    if (!el) return;

    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      el.textContent = formatMoneyFromCents(cart.items_subtotal_price || 0);
    } catch (e) {
      // if something fails, don't break the cart UI
      console.log('Donation update failed', e);
    }
  }

  // 1) Run on page load
  document.addEventListener('DOMContentLoaded', updateDonation);

  // 2) Run when user adds/removes via AJAX (Minimog/Shopify themes often fire these)
  document.addEventListener('cart:refresh', updateDonation);
  document.addEventListener('ajax:addToCart', updateDonation);

  // 3) Very reliable fallback: whenever the cart drawer DOM changes, update
  const observer = new MutationObserver(() => updateDonation());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();